import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import api from '../../../../services/API';
import { toast } from 'react-toastify';
import { Form, Input } from '@rocketseat/unform';

export default function ModalEditar(props) {
  const [editando, setEditando] = useState(false);
  const [data, setData] = useState({});
  const [descricao, setDescricao] = useState('');
  const [nome, setNome] = useState('');
  const [codigo, setCodigo] = useState('');
  const [custo, setCusto] = useState('');
  const [custoReal, setCustoReal] = useState('');
  const [tipo, setTipo] = useState('');
  const [foto, setFoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [status, setStatus] = useState('Procurar...');
  const [hasLimiteResgate, setHasLimiteResgate] = useState(false);
  const [limiteResgate, setLimiteResgate] = useState('');

  const alterarFoto = async (e) => {
    if (e.target.files.length > 0) {
      setStatus(`${e.target.files[0].name}`);
      setFoto(e.target.files[0]);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      setStatus('Procurar...');
      setPreview(null);
    }
  };

  const atualizar = async (e) => {
    e.preventDefault();
    
    if (!nome) {
      toast.error('Informe o nome');
      return;
    }

    if (!codigo) {
      toast.error('Informe o código');
      return;
    }

    if (!descricao) {
      toast.error('Informe a descrição');
      return;
    }

    if (!custo) {
      toast.error('Informe o custo');
      return;
    }

    setEditando(true);

    let formData = new FormData();
    formData.append('nome', nome);
    formData.append('descricao', descricao);
    formData.append('codigo', codigo);
    formData.append('custo', Number(custo));
    if (custoReal) {
      formData.append('custoReal', Number(custoReal));
    }
    formData.append('tipo', tipo === 'geral' ? '' : tipo);
    if (limiteResgate && parseInt(limiteResgate) >= 1) {
      formData.append('hasLimiteResgate', true);
      formData.append('limiteResgate', Number(limiteResgate));
    } else {
      formData.append('hasLimiteResgate', false);
      formData.append('limiteResgate', '');
    }
    
    if (foto) {
      formData.append('foto', foto);
    }

    try {
      const resultado = await api.put(`/api/premios/${data.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (resultado) {
        toast.success('Prêmio atualizado com sucesso', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
        props.onHide();
        props.atualizarPremio({
          ...{ 
            nome, 
            descricao, 
            codigo, 
            custo: Number(custo) / 100, 
            tipo: tipo === 'geral' ? null : tipo,
            hasLimiteResgate: limiteResgate && parseInt(limiteResgate) >= 1,
            limiteResgate: limiteResgate && parseInt(limiteResgate) >= 1 ? Number(limiteResgate) : null
          },
          id: data.id,
        });
      }
    } catch (error) {
      console.error('Erro ao atualizar:', error);
      toast.error('Erro ao atualizar prêmio', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
    } finally {
      setEditando(false);
    }
  };

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setNome(props.data.nome);
      setDescricao(props.data.descricao);
      setCodigo(props.data.codigo);
      setCusto(Number(props.data.custo));
      setCustoReal(props.data.custoReal ? Number(props.data.custoReal) : '');
      setTipo(props.data.tipo === null || props.data.tipo === '' ? 'geral' : props.data.tipo);
      setLimiteResgate(props.data.limiteResgate ? String(props.data.limiteResgate) : '');
      setHasLimiteResgate(props.data.hasLimiteResgate === true || props.data.hasLimiteResgate === 1 || false);
      setPreview(props.data.diretorioFoto);
      setStatus('Procurar...');
    }
  }, [props]);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mt-3 mb-3">
        <div className="d-flex flex-column align-items-center">
          <Form className="form" onSubmit={atualizar}>
            <label htmlFor="foto">Foto</label>
            <input
              type="file"
              id="foto"
              name="foto"
              style={{ display: 'none' }}
              onChange={alterarFoto}
            />
            <input
              className="text-left"
              id="botao"
              type="button"
              value={status}
              onClick={(e) => {
                document.getElementById('foto').click();
              }}
            />
            {preview && (
              <img alt="Preview" src={preview} className="mt-3 mb-3 w-100" />
            )}
            <label htmlFor="codigo">Código</label>
            <Input
              id="codigo"
              name="codigo"
              type="text"
              placeholder="Código"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
            />
            <label htmlFor="nome">Nome</label>
            <Input
              id="nome"
              name="nome"
              type="text"
              placeholder="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <label htmlFor="descricao">Descrição</label>
            <textarea
              id="descricao"
              name="descricao"
              placeholder="Descrição"
              className="premio-desc p-2"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
            <label htmlFor="custo">Valor em Pontos</label>
            <Input
              id="custo"
              name="custo"
              type="number"
              step="0.01"
              min="0"
              placeholder="150"
              value={custo}
              onChange={(e) => setCusto(e.target.value)}
            />
            <label htmlFor="custoReal">Custo Real (Opcional)</label>
            <Input
              id="custoReal"
              name="custoReal"
              type="number"
              step="0.01"
              min="0"
              value={custoReal}
              onChange={(e) => setCustoReal(e.target.value)}
            />
            <label htmlFor="tipo" className="mt-3">Tipo</label>
            <select
              id="tipo"
              name="tipo"
              placeholder="Tipo"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            >
              <option value="geral">Geral</option>
              <option value="bivolt">Bivolt</option>
              <option value="credito">Crédito</option>
              <option value="recarga">Recarga</option>
            </select>
            <label htmlFor="limiteResgate">Limite de Resgate (Opcional)</label>
            <Input
              id="limiteResgate"
              name="limiteResgate"
              type="number"
              min="1"
              placeholder="Ex: 100"
              value={limiteResgate}
              onChange={(e) => {
                const valor = e.target.value;
                setLimiteResgate(valor);
                setHasLimiteResgate(valor !== '' && parseInt(valor) >= 1);
              }}
            />
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center w-100">
          {editando ? (
            <button
              type="button"
              className="btn btn-success m-1"
              onClick={atualizar}
              disabled
            >
              SALVANDO...
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-success m-1"
              onClick={atualizar}
            >
              SALVAR
            </button>
          )}
          <button
            type="button"
            className="btn btn-danger m-1"
            onClick={props.onHide}
          >
            CANCELAR
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
